import { useState, useEffect } from 'react';

type TeamColor = 'BLUE' | 'RED' | 'GREEN';

interface AudiencePreviewProps {
  sessionId: string;
}

const TEAM_CONFIG: Record<TeamColor, { label: string; border: string }> = {
  BLUE: { label: 'Blu', border: 'border-blue-500' },
  RED: { label: 'Rossa', border: 'border-red-500' },
  GREEN: { label: 'Verde', border: 'border-green-500' },
};

function AudiencePreview({ sessionId }: AudiencePreviewProps) {
  const [spectators, setSpectators] = useState<Record<TeamColor, string> | null>(null);

  // Crea/ottieni spectator audience members
  useEffect(() => {
    fetch(`/api/audience-state/spectators/${sessionId}`, { method: 'POST' })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSpectators(data.spectators);
        }
      })
      .catch((err) => console.error('[AudiencePreview] Error creating spectators:', err));
  }, [sessionId]);

  if (!spectators) {
    return (
      <div className="h-full flex items-center justify-center bg-gray-950">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500 mx-auto mb-3"></div>
          <p className="text-sm text-gray-400">Connessione spectator...</p>
        </div>
      </div>
    );
  }

  const teams: TeamColor[] = ['BLUE', 'RED', 'GREEN'];

  return (
    <div className="h-full flex gap-2 p-2 bg-gray-950">
      {teams.map((team) => {
        const config = TEAM_CONFIG[team];
        const iframeUrl = `/audience?spectator=true&session=${sessionId}&team=${team}&audienceId=${spectators[team]}`;

        return (
          <div
            key={team}
            className={`flex-1 rounded-lg border-2 ${config.border} overflow-hidden flex flex-col`}
          >
            {/* Team label */}
            <div className="px-2 py-1 bg-black/60 text-center flex-shrink-0">
              <span className="text-xs font-bold text-gray-300">Squadra {config.label}</span>
            </div>

            {/* Audience screen via iframe */}
            <div className="flex-1 relative overflow-hidden">
              <iframe
                src={iframeUrl}
                className="absolute inset-0 w-full h-full border-0 pointer-events-none"
                title={`Audience ${team}`}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default AudiencePreview;
